import { Box, CircularProgress } from '@mui/material';
import React from 'react';

export interface ImpersonationFrameDialogProps {
  open: boolean;
  src: string | null;
  onLoaded?: () => void;
  isLoading: boolean;
}

const ImpersonationFrameDialog: React.FC<ImpersonationFrameDialogProps> = ({
  open,
  src,
  onLoaded,
  isLoading,
}) => {
  if (!open || !src) {
    return null;
  }

  return (
    <Box
      role='dialog'
      aria-modal='true'
      sx={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'stretch',
        zIndex: (theme) => theme.zIndex.modal + 1,
        bgcolor: 'background.default',
        paddingTop: 'var(--safe-area-inset-top, env(safe-area-inset-top, 0px))',
        paddingBottom:
          'var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          flex: 1,
          bgcolor: 'background.default',
        }}
      >
        <Box
          component='iframe'
          src={src}
          title='impersonation-frame'
          onLoad={onLoaded}
          sx={{
            width: '100%',
            height: '100%',
            border: 0,
            position: 'relative',
            zIndex: 1,
            bgcolor: 'background.default',
          }}
        />

        {isLoading ? (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              bgcolor: 'background.default',
              zIndex: 2,
            }}
          >
            <CircularProgress size={48} />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default React.memo(ImpersonationFrameDialog);
